<header>
  <div class="title">
    <h2>{{ brandName }}</h2>
    <div class="new-campaign-wrapper">
      <button class="btn btn--primary" (click)="newCampaign()">
        {{ "brand.campaignList.newCampaign" | translate }}
      </button>
      <div class="start-here" *ngIf="!loading && campaigns?.length === 0">
        <div class="start-here--text">
          <h2>{{ "brand.campaign.startHere.title" | translate }}</h2>
          <p>{{ "brand.campaign.startHere.text" | translate }}</p>
        </div>
        <img
          class="start-here--image"
          src="assets/images/as_create_campaign.svg"
        />
      </div>
    </div>
  </div>
  <div class="search">
    <mat-icon>search</mat-icon
    ><input
      type="search"
      placeholder="{{ 'brand.campaignList.searchPlaceholder' | translate }}"
      (input)="onSearchChange($event)"
    />
  </div>
</header>
<div class="loader-wrapper">
  <section class="container">
    <section class="campaigns-section">
      <div class="campaign-filters">
        <div class="status-filter" (clickOutside)="showFilter = false">
          <button class="button" (click)="showFilter = !showFilter">
            {{
              (filterSelected()
                ? "brand.campaignList.campaigns"
                : "brand.campaignList.allCampaigns"
              ) | translate
            }}
            ({{ shownCampaigns?.length }})
            <div class="arrow"></div>
          </button>
          <div class="filter-menu" *ngIf="showFilter">
            <ul class="filter-list">
              <li class="filter-item" (click)="onViewAllCampaigns()">
                <img src="/assets/images/icons/ic_viewAll.svg" />
                <span>{{ "brand.campaignList.viewAll" | translate }}</span>
              </li>
              @for (
                filter of STATUS_FILTERS | keyvalue: valueAscOrder;
                track filter.key
              ) {
                <li
                  class="filter-item"
                  [ngClass]="{
                    'filter-item--active': isFilterActive(filter.key)
                  }"
                  (click)="onFilterCampaigns(filter.key)"
                >
                  <img src="/assets/images/icons/{{ filter.value.icon }}.svg" />
                  <span>{{ filter.value.label | translate }}</span>
                </li>
              }
            </ul>
          </div>
        </div>
        <button class="sort-button" (click)="onChangeOrder()">
          <span>{{ "brand.campaignList.byDate" | translate }}</span>
          <mat-icon [ngClass]="{ 'mirror-y': sortMode === SORT_MODES.Asc }"
            >sort</mat-icon
          >
        </button>
      </div>
      <div class="campaign-list">
        @for (campaign of shownCampaigns; track campaign.id) {
          <app-brand-campaign-item
            [campaign]="campaign"
            [isDeleting]="deletingCampaignId === campaign.id"
            (move)="showMoveCampaignDialog(campaign)"
            (duplicate)="duplicateCampaignConfirm(campaign)"
            (delete)="deleteCampaignConfirm(campaign)"
          />
        }
      </div>
    </section>
  </section>
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  />
</div>
<div *ngIf="loadingError" class="reload-wrap">
  <app-reload (action)="getCampaigns()" />
</div>
